module.exports = __webpack_public_path__ + "static/media/YESTERYEAR_back.32be68b3.jpg";